export default __webpack_public_path__ + "static/media/folder_icon.2d685b8c.svg";